import {AxiosPost} from "./axios";

export default {
  //判断数组
  isArray: function (arr) {
    let outPutArr = [];
    if (Object.prototype.toString.call(arr) === "[object Array]") {
      outPutArr = arr;
    }
    return outPutArr;
  },

  //判断对象
  isObject: function (obj) {
    let outPutObj = {};
    if (Object.prototype.toString.call(obj) === "[object Object]") {
      outPutObj = obj;
    }
    return outPutObj;
  },

  //判断字符串类型
  isString: function (str) {
    let outPutStr = '';
    if (Object.prototype.toString.call(str) === "[object String]") {
      outPutStr = str;
    }
    return outPutStr;
  },

  //取sessionStorage 里面的值
  getStorage: function (key, type) {
    let storage_tips = window.sessionStorage.getItem(key);

    if (storage_tips) storage_tips = JSON.parse(storage_tips);

    if (type === 'object') {
      return this.isObject(storage_tips);
    } else if (type === 'string') {
      return this.isString(storage_tips);
    } else if (type === 'array') {
      return this.isArray(storage_tips);
    } else {
      return storage_tips;
    }
  },

  //存sessionStorage 里面的值
  setStorage: function (key, item) {
    let meta = null;
    let type = typeof(item);

    if (type === 'object' || type === 'array') {
      meta = JSON.stringify(item);
    } else {
      meta = item;
    }

    window.sessionStorage.setItem(key, meta);
  },
  removeStorage: function (key) {
    window.sessionStorage.removeItem(key);
  },

  //取localStorage 里面的值
  getLocalStorage: function (key, type) {
    let storage_tips = window.localStorage.getItem(key);

    if (storage_tips) storage_tips = JSON.parse(storage_tips);

    if (type === 'object') {
      return this.isObject(storage_tips);
    } else if (type === 'string') {
      return this.isString(storage_tips);
    } else if (type === 'array') {
      return this.isArray(storage_tips);
    } else {
      return storage_tips;
    }
  },

  //localStorage 里面的值
  setLocalStorage: function (key, item) {
    let meta = null;
    let type = typeof(item);

    if (type === 'object' || type === 'array') {
      meta = JSON.stringify(item);
    } else {
      meta = item;
    }

    window.localStorage.setItem(key, meta);
  },
  removeLocalStorage: function (key) {
    window.localStorage.removeItem(key);
  },
  // 验证身份证号
  isIdCardNo: function (num) {
    var factorArr = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1);
    var parityBit = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2");
    var varArray = new Array();
    var intValue;
    var lngProduct = 0;
    var intCheckDigit;
    var intStrLen = num.length;
    var idNumber = num;
    if ((intStrLen != 15) && (intStrLen != 18)) {
      return false;
    }
    for (let i = 0; i < intStrLen; i++) {
      varArray[i] = idNumber.charAt(i);
      if ((varArray[i] < '0' || varArray[i] > '9') && (i != 17)) {
        return false;
      } else if (i < 17) {
        varArray[i] = varArray[i] * factorArr[i];
      }
    }

    if (intStrLen == 18) {
      var date8 = idNumber.substring(6, 14);
      if (this.isDate8(date8) == false) {
        return false;
      }
      for (let i = 0; i < 17; i++) {
        lngProduct = lngProduct + varArray[i];
      }
      intCheckDigit = parityBit[lngProduct % 11];
      if (varArray[17] != intCheckDigit) {
        return false;
      }
    }
    else {
      var date6 = idNumber.substring(6, 12);
      if (this.isDate8(date6) == false) {

        return false;
      }
    }
    return true;

  },
  isDate8: function (sDate) {
    if (!/^[0-9]{8}$/.test(sDate)) {
      return false;
    }
    var year, month, day;
    year = sDate.substring(0, 4);
    month = sDate.substring(4, 6);
    day = sDate.substring(6, 8);
    var iaMonthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    if (year < 1700 || year > 2500) return false
    if (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) iaMonthDays[1] = 29;
    if (month < 1 || month > 12) returnfalse
    if (day < 1 || day > iaMonthDays[month - 1]) return false
    return true
  },
  // 验证电话号码
  checkPhones: function (v) {
    if (!(/^[1][3,4,5,,6,7,8,9][0-9]{9}$/.test(v))) {
      return false;
    } else {
      return true
    }
  },
  //手机号码隐藏显示*
  phoneHide: function (nub) {
    let tel = nub;
    tel = "" + tel;
    let tel1 = tel.substr(0, 3) + "****" + tel.substr(7)
    return tel1
  },
  // 解析url参数并获取code
  getUrlParam: function (name) {   //name为要获取的参数名
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var rrr = decodeURIComponent(window.location.search);
    var r = rrr.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  delParam: function (paramKey) {
    var url = window.location.href;    //页面url
    var urlParam = window.location.search.substr(1);   //页面参数
    var beforeUrl = url.substr(0, url.indexOf("?"));   //页面主地址（参数之前地址）
    var nextUrl = "";

    var arr = new Array();
    if (urlParam != "") {
      var urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
      for (var i = 0; i < urlParamArr.length; i++) {
        var paramArr = urlParamArr[i].split("="); //将参数键，值拆开
        //如果键雨要删除的不一致，则加入到参数中
        if (paramArr[0] != paramKey) {
          arr.push(urlParamArr[i]);
        }
      }
    }
    if (arr.length > 0) {
      nextUrl = "?" + arr.join("&");
    }
    url = beforeUrl + nextUrl;
    console.log(url);
    return url;
  },
  //是否微信浏览器
  getIsWxClient: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    }
    return false;
  },
}




// WEBPACK FOOTER //
// ./src/api/utils.js